function r(t) {
  let e = new Date(t), l = ("0" + e.getDate()).slice(-2), a = ("0" + (e.getMonth() + 1)).slice(-2), n = e.getFullYear();
  return l + "/" + a + "/" + n;
}
export {
  r as britishDate
};
